// extracted by css-extract-rspack-plugin
export default {"cls1":"TriagePage-cls1_OEM","cls2":"TriagePage-cls2_bXm TriagePage-cls1_OEM"};